module.exports = __webpack_public_path__ + "img/wallys_blog_pwa.a47c8741.png";